/* eslint no-undef:0 */
export default function( $ ) {
  /* ----------------------------------------------------------- */
  /*  OPEN / CLOSE TOGGLE Produktbewertung
  /* ----------------------------------------------------------- */
  (
    function() {
      $( '.open-close' ).on( 'click', (e) => {
        const $target = $( '.target' );
        if ( $target.is( ':hidden' ) ) {
          $target.fadeIn();
        } else {
          $target.fadeOut();
        }

        // React Fallback toggle
        if ( window.CommentFormEventEmitter ) {
          CommentFormEventEmitter.emit( 'COMMENTS_FORM_TOGGLED' );
        }

        $( e.currentTarget ).toggleClass( 'ButtonClicked' );
      } );
    }
  )();

}
